import { connect } from 'react-redux'
import { bindActionCreators, Dispatch } from 'redux'
import styled from 'styled-components'

import { EnhancedPureComponent } from '@/components'
import { StructureDto } from '@/rtkApi/mddApiSliceGenerated'
import { RootState } from '@/store'
import { openTab } from '@/store/modules/tab/actions'
import { getBreadcrumbs } from '@/utils'

type Props = ReturnType<typeof mapStateToProps> &
	ReturnType<typeof mapDispatchToProps> & {
		node: StructureDto | null
	}

const mapStateToProps = (state: RootState) => ({
	nodes: state.node.nodes,
})

const mapDispatchToProps = (dispatch: Dispatch) =>
	bindActionCreators(
		{
			openTab,
		},
		dispatch,
	)

class BreadcrumbComponent extends EnhancedPureComponent<Props> {
	handleClick = (node: StructureDto) => {
		this.props.openTab(node, true)
	}

	render() {
		const { node, nodes } = this.props

		if (!node || !nodes) {
			return null
		}

		const breadcrumbs = getBreadcrumbs(node, nodes)

		return (
			<Container role="navigation" aria-label="Breadcrumb">
				{breadcrumbs.map((n) => (
					<Item key={n.id} onClick={() => this.handleClick(n)} title={n.name}>
						<ItemText> {n.name}</ItemText>
					</Item>
				))}
				<ActiveItem title={node.name}>
					<ItemText>{node.name}</ItemText>
				</ActiveItem>
			</Container>
		)
	}
}

export const Container = styled.div`
	display: flex;
	flex-wrap: wrap;
	padding: 6px 10px;
	background: #fff;
`
export const Item = styled.a`
	display: flex;
	margin: 0 4px 2px 4px;
	color: #333;
	user-select: none;
	&:hover {
		color: #777;
	}
	&:not(:last-child):after {
		content: '>';
		margin-left: 8px;
		color: #999;
	}
`

export const ActiveItem = styled(Item)`
	font-weight: 600;
`

const ItemText = styled.div`
	max-width: 400px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
`

export const Breadcrumb = connect(
	mapStateToProps,
	mapDispatchToProps,
)(BreadcrumbComponent)
